import {
  SUBMIT_ORDER_REQUEST,
  SUBMIT_ORDER_SUCCESS,
  SUBMIT_ORDER_ERROR,
  ORDER_PAYMENT_DETAILS_SUCCESS,
  ORDER_GET_ORDER_DETAILS_REQUEST,
  ORDER_GET_ORDER_DETAILS_SUCCESS,
  ORDER_GET_ORDER_DETAILS_FAILURE,
  ORDER_GET_TEMPLATE_ORDER_DETAILS_REQUEST,
  ORDER_GET_TEMPLATE_ORDER_DETAILS_SUCCESS,
  ORDER_GET_TEMPLATE_ORDER_DETAILS_FAILURE,
} from '@/actions';
import {
  GET_ELIGIBLE_LINE_COUNT_REQUEST,
  GET_ELIGIBLE_LINE_COUNT_SUCCESS,
  GET_ELIGIBLE_LINE_COUNT_FAILURE,
  SET_NO_OF_LINE_REQUEST,
  GET_DIST_CARD_PROFILE_SUCCESS,
  GET_DIST_CARD_PROFILE_REQUEST,
  GET_DIST_CARD_PROFILE_FAILURE,
  ORDER_SAVE_TO_CART_REQUEST,
  ORDER_SAVE_TO_CART_SUCCESS,
  ORDER_SAVE_TO_CART_FAILURE,
  ORDER_CREATE_NEW_ORDER_STORE,
  PDPA_GET_ORDER_DETAILS_FAILURE,
  PDPA_GET_ORDER_DETAILS_REQUEST,
  PDPA_GET_ORDER_DETAILS_SUCCESS,
  TERMINATE_PARENT_SVC_NUM_FAILURE,
  GET_SIM_CHARGE_FAILURE,
  GET_SIM_CHARGE_REQUEST,
  GET_SIM_CHARGE_SUCCESS,
  GET_RESET_CARD_PROFILE,
  GET_WAIVERED_ORDER_REQUEST,
  GET_WAIVERED_ORDER_SUCCESS,
  GET_WAIVERED_ORDER_FAILURE,
  WAIVER_REQUEST_STATUS_UPDATE_FAILURE,
  WAIVER_REQUEST_STATUS_UPDATE_REQUEST,
  WAIVER_REQUEST_STATUS_UPDATE_SUCCESS,
  ORDER_SAVE_SMART_TEMPLATE_FAILURE,
  ORDER_SAVE_SMART_TEMPLATE_REQUEST,
  ORDER_SAVE_SMART_TEMPLATE_SUCCESS,
  SET_IS_SMART_TEMPLATE_FLOW,
  SET_DELETE_SMART_TEMPLATE_ID,
  REFIT_LINE_SUBMIT_REQUEST,
  REFIT_LINE_SUBMIT_SUCCESS,
  REFIT_LINE_SUBMIT_ERROR,
  PDPA_QR_IMAGE_RET_REQUEST,
  PDPA_QR_IMAGE_RET_SUCCESS,
  PDPA_QR_IMAGE_RET_ERROR,
  GET_BULK_ORDER_DETAILS_BY_ITEM_ID_REQUEST,
  GET_BULK_ORDER_DETAILS_BY_ITEM_ID_ERROR,
  GET_BULK_ORDER_DETAILS_BY_ITEM_ID_SUCCESS
} from '@/actions/order/actionTypes';

import {
  // IGetEligibleLineCountResponse,
  IOrderDetails
} from './models/orderModel';
export const initialState = {
  error: '',
  errorGroup: {},
  isLoading: false,
  isSaving: false,
  currentOrder: {} as IOrderDetails,
  submitOrderLoading: false,
  orderInfo: {},
  countData: {}, //as IGetEligibleLineCountResponse,
  isEligibleCountLoading: false,
  getEligibleCountError: '',
  cardProfile: [],
  terminateParentSvcNoError: '',
  pdpaOrder: {},
  bulkPdpaOrder: {},
  otc: 0,
  waiverOrderDetails: {
    isLoading: false,
    orderDetails: {},
    isApprovalLoading: false,
    approvalOrderStatus: '',
    isError: ''
  },
  isSmartTemplate: false,
  isTemplateFlow: false,
  isSavingTemplate: false,
  isTemplateLoading: false,
  templateDetails: {},
  templateData: {},
  isSaveTemplateError: '',
  refitLineSubmitLoading: false,
  refitLineSubmitData: {},
  esimPdpaQrOrderId: '',
  esimPdpaQrCreatedDate: '',
  esimPdpaQrLoading: false,
  esimPdpaQrSvcNo: '',
  esimPdpaQrImgTxt: '',
  esimPdpaQrError: '',
  esimPdpaQrSuccess: false,
  esimPdpaQrIsError: false,
};

const getWaiveredTemplateDetail = (action, state) => {
  switch (action.type) {
    case GET_WAIVERED_ORDER_REQUEST:
      return {
        ...state,
        waiverOrderDetails: {
          ...state.waiverOrderDetails,
          isLoading: true,
          isError: ''
        }
      }
    case GET_WAIVERED_ORDER_SUCCESS:
      return {
        ...state,
        waiverOrderDetails: {
          ...state.waiverOrderDetails,
          isLoading: false,
          orderDetails: action.data
        }
      }
    case GET_WAIVERED_ORDER_FAILURE:
      return {
        ...state,
        waiverOrderDetails: {
          ...state.waiverOrderDetails,
          isLoading: false,
          orderDetails: {},
          isError: action.error.response?.data?.message || 'Something went wrong with our system, please contact our customer support or try again later.'
        }
      }

    case WAIVER_REQUEST_STATUS_UPDATE_REQUEST:
      return {
        ...state,
        waiverOrderDetails: {
          ...state.waiverOrderDetails,
          isApprovalLoading: true,
          approvalOrderStatus: '',
          isError: ''
        }
      }
    case WAIVER_REQUEST_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        waiverOrderDetails: {
          ...state.waiverOrderDetails,
          isApprovalLoading: false,
          orderDetails: action.data,
          approvalOrderStatus: action.data.orderStatus
        }
      }
    case WAIVER_REQUEST_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        waiverOrderDetails: {
          ...state.waiverOrderDetails,
          isApprovalLoading: false,
          approvalOrderStatus: '',
          isError: action.error.response?.data?.message
        }
      }
  }
}

const esimQrPdpaRetrieval = (state = initialState, action) => {
  switch (action.type) {
    case PDPA_QR_IMAGE_RET_REQUEST:
      return {
        ...state,
        esimPdpaQrLoading: true,
        esimPdpaQrSuccess: false,
        esimPdpaQrIsError: false,
      };
    case PDPA_QR_IMAGE_RET_SUCCESS: {
      const { createdDate, orderId, qrText, svcNo } = action.data;
      return {
        ...state,
        esimPdpaQrOrderId: orderId,
        esimPdpaQrCreatedDate: createdDate,
        esimPdpaQrLoading: false,
        esimPdpaQrSvcNo: svcNo,
        esimPdpaQrImgTxt: qrText,
        esimPdpaQrSuccess: true,
        esimPdpaQrIsError: false,
      };
    };
    case PDPA_QR_IMAGE_RET_ERROR:
      return {
        ...state,
        esimPdpaQrLoading: false,
        esimPdpaQrIsError: true,
        esimPdpaQrError: action.error.response?.data?.message,
        esimPdpaQrSuccess: false
      }
  }
}

const getSmartTemplateDetail = (action, state) => {
  switch (action.type) {
    case ORDER_SAVE_SMART_TEMPLATE_REQUEST:
      return {
        ...state,
        isSavingTemplate: true,
        isSaveTemplateError: ''
      }
    case ORDER_SAVE_SMART_TEMPLATE_SUCCESS:
      return {
        ...state,
        isSavingTemplate: false,
        templateDetails: action.data
      }
    case ORDER_SAVE_SMART_TEMPLATE_FAILURE:
      return {
        ...state,
        isSavingTemplate: false,
        isSaveTemplateError: 'Something went wrong with our system while saving the Template',
        templateDetails: {}
      }

    case ORDER_GET_TEMPLATE_ORDER_DETAILS_REQUEST:
      return {
        ...state,
        isTemplateFlow: false,
        isTemplateLoading: true,
        templateData: {},
        isTemplateFlowError: ''
      }
    case ORDER_GET_TEMPLATE_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        isTemplateFlow: true,
        isTemplateLoading: false,
        templateData: action.data,
      }
    case ORDER_GET_TEMPLATE_ORDER_DETAILS_FAILURE:
      return {
        ...state,
        isTemplateLoading: false,
        templateData: {},
        isTemplateFlowError: action.error.response?.data?.message || 'Something went wrong with our system, please contact our customer support or try again later.'
      }
  }
}

const orderReducers = (state = initialState, action) => {
  switch (action.type) {
    case ORDER_SAVE_TO_CART_REQUEST:
      return {
        ...state,
        isSaving: !action.recalculateOnly //only shows loading status when saving to cart
      };
    case ORDER_SAVE_TO_CART_SUCCESS: {
      const { recalculateOnly, shoppingCartId, errorGroup, checkout, serFlow, hybridSerFlow } = action.data;
      return {
        ...state,
        isSaving: false,
        error: '',
        errorGroup,
        currentOrder: recalculateOnly || checkout ? action.data : { ...state.currentOrder, shoppingCartId, serFlow, hybridSerFlow }
      };
    };
    case ORDER_SAVE_TO_CART_FAILURE:
      return {
        ...state,
        error: action.error?.response?.data,
        isSaving: false
      };

    case ORDER_GET_ORDER_DETAILS_REQUEST:
    case PDPA_GET_ORDER_DETAILS_REQUEST:
    case GET_BULK_ORDER_DETAILS_BY_ITEM_ID_REQUEST:
      return {
        ...state,
        error: '',
        errorGroup: {},
        isLoading: true,
        templateDetails: {}
      };
    case ORDER_GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        currentOrder: action.data,
        isLoading: false
      };
    case GET_BULK_ORDER_DETAILS_BY_ITEM_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        bulkPdpaOrder: action.data,
      };

    case ORDER_CREATE_NEW_ORDER_STORE:
      return {
        ...state,
        currentOrder: action.order,
        error: '',
        countData: {},
        getEligibleCountError: ''
      };

    case 'ORDER_STORE_SELECTION':
      return {
        ...state,
        currentOrder: {
          ...state.currentOrder,
          activeStep: action.activeStep,
          cartDetails: {
            ...state.currentOrder.cartDetails,
            ...action.selection
          }
        }
      };

    case SUBMIT_ORDER_REQUEST:
      return {
        ...state,
        submitOrderLoading: true
      };
    case SUBMIT_ORDER_SUCCESS:
      return {
        ...state,
        orderInfo: action.data,
        submitOrderLoading: false
      };
    case SUBMIT_ORDER_ERROR:
      return {
        ...state,
        orderInfo: {},
        submitOrderLoading: false
      };

    case ORDER_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        orderInfo: action.data
      };

    case GET_ELIGIBLE_LINE_COUNT_REQUEST:
      return {
        ...state,
        isEligibleCountLoading: true
      };
    case GET_ELIGIBLE_LINE_COUNT_SUCCESS:
      return {
        ...state,
        countData: action.data,
        isEligibleCountLoading: false,
        getEligibleCountError: ''
      };
    case GET_ELIGIBLE_LINE_COUNT_FAILURE:
      return {
        ...state,
        countData: {},
        isEligibleCountLoading: false,
        getEligibleCountError: action.error.response?.data?.message || 'GET_ELIGIBLE_LINE_COUNT_API_FAILED_ERROR'
      };

    case SET_NO_OF_LINE_REQUEST:
      return {
        ...state,
        currentOrder: {
          ...state.currentOrder,
          cartDetails: {
            ...state.currentOrder.cartDetails,
            pricePlan: {
              ...state.currentOrder.cartDetails?.pricePlan,
              noOfLines: action.noOfLines.noOfLines
            }
          }
        }
      };

    case GET_DIST_CARD_PROFILE_REQUEST:
      return {
        ...state,
        cardProfile: [],
        isLoading: true
      };
    case GET_DIST_CARD_PROFILE_SUCCESS:
      return {
        ...state,
        cardProfile: action.data,
        isLoading: false
      };
    case ORDER_GET_ORDER_DETAILS_FAILURE:
    case GET_DIST_CARD_PROFILE_FAILURE:
    case GET_SIM_CHARGE_FAILURE:
      return {
        ...state,
        error: action.error?.response?.data,
        isLoading: false
      };

    case PDPA_GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pdpaOrder: action.data
      };
    case PDPA_GET_ORDER_DETAILS_FAILURE:
    case GET_BULK_ORDER_DETAILS_BY_ITEM_ID_ERROR:
      return {
        ...state,
        error: action.error.response?.data,
        isLoading: false,
        pdpaOrder: {}
      };

    case GET_SIM_CHARGE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_SIM_CHARGE_SUCCESS:
      return {
        ...state,
        otc: action.data.otc,
        isLoading: false
      };
    case GET_RESET_CARD_PROFILE:
      return {
        ...state,
        cardProfile: []
      };

    case GET_WAIVERED_ORDER_REQUEST:
    case GET_WAIVERED_ORDER_SUCCESS:
    case GET_WAIVERED_ORDER_FAILURE:
    case WAIVER_REQUEST_STATUS_UPDATE_REQUEST:
    case WAIVER_REQUEST_STATUS_UPDATE_SUCCESS:
    case WAIVER_REQUEST_STATUS_UPDATE_FAILURE:
      return getWaiveredTemplateDetail(action, state)

    case ORDER_SAVE_SMART_TEMPLATE_REQUEST:
    case ORDER_SAVE_SMART_TEMPLATE_SUCCESS:
    case ORDER_SAVE_SMART_TEMPLATE_FAILURE:
    case ORDER_GET_TEMPLATE_ORDER_DETAILS_REQUEST:
    case ORDER_GET_TEMPLATE_ORDER_DETAILS_SUCCESS:
    case ORDER_GET_TEMPLATE_ORDER_DETAILS_FAILURE:
      return getSmartTemplateDetail(action, state)

    case TERMINATE_PARENT_SVC_NUM_FAILURE:
      return {
        ...state,
        terminateParentSvcNoError: action.error.response?.data?.message
      };

    case SET_IS_SMART_TEMPLATE_FLOW:
      return {
        ...state,
        isTemplateFlow: action.data
      };

    case SET_DELETE_SMART_TEMPLATE_ID:
      return {
        ...state,
        currentOrder: {
          ...state.currentOrder,
          deleteTemplateId: action.data
        }
      };
    case REFIT_LINE_SUBMIT_REQUEST:
      return {
        ...state,
        refitLineSubmitLoading: true
      };
    case REFIT_LINE_SUBMIT_SUCCESS:
      return {
        ...state,
        refitLineSubmitData: action.data,
        refitLineSubmitLoading: false
      };
    case REFIT_LINE_SUBMIT_ERROR:
      return {
        ...state,
        refitLineSubmitLoading: false
      };

    case PDPA_QR_IMAGE_RET_REQUEST:
    case PDPA_QR_IMAGE_RET_SUCCESS:
    case PDPA_QR_IMAGE_RET_ERROR:
      return esimQrPdpaRetrieval(state, action)

    default:
      return state;
  }
};

export default orderReducers;
